import { Component, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ServerSelectComponent } from '../../server-select/server-select.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'subscription-id-request',
    imports: [
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinner,
        ServerSelectComponent,
        TranslateModule
    ],
    templateUrl: './subscription-id-request.component.html',
    styleUrl: './subscription-id-request.component.css'
})
export class SubscriptionIdRequestComponent {

  processing = model(false); // Tracks whether the request is in progress.
  submitRequest = output<string>();

  subscriptionId = signal<string>('');

  onSubmit(): void {
    if (this.processing()) return;

    this.processing.set(true); // Disable inputs and show the spinner.

    this.submitRequest.emit(this.subscriptionId().trim());
  }


}
